import { Space, SpaceInfo } from "../types";

const uuidRegex = new RegExp("[a-f0-9]{32}");

export function spaceDisplayName(
  id: Space["id"],
  name: SpaceInfo["name"] | undefined | null
) {
  let label = name ?? id;

  if (uuidRegex.test(label)) {
    label = label.slice(0, 6);
  }

  return label;
}
